import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'
const base = 'orders'

AdminRouter.addRoutes([
  {
    name: `${base}`,
    path: `/${base}`,
    component: () => import('./Index.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.pay`,
    path: `/${base}/:id`,
    component: () => import('./Pay.vue'),
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: `${base}`,
  order: 20,
  header: $vm => $vm.$t(`general.menu_main`),
  text: $vm => $vm.$t(`${base}.title`),
  route: {
    name: `${base}`,
  },
  icon: 'icon-coins',
  permission: () => true,
})

messageGroups.push(base)
